import { Box, Button, Dialog, Portal, Stack } from '@chakra-ui/react'
import { useQueryClient } from '@tanstack/react-query'
import { useStore } from '@tanstack/react-store'
import { Field, Formik } from 'formik'
import { useBoolean } from 'react-use'
import { userCardStore } from 'shared/store/userCard'
import { SelectForm } from 'uikit'
import { Form } from 'uikit/Form'
import { FormUploadImage } from 'uikit/FormUploadImage'
import * as Yup from 'yup'
import { useUploadScans } from './services/useUploadScans'

const optionsRussia = [
  {
    label: 'Фото из паспорта РФ (загруженное поддержкой)',
    value: 'RUSSIA_PHOTO_FROM_PASSPORT_SUPPORT',
  },
  {
    label: 'Селфи (загруженное поддержкой)',
    value: 'SELFIE_WITH_PASSPORT_SUPPORT',
  },
  {
    label: 'Первая страница паспорта (загруженное поддержкой)',
    value: 'PASSPORT_FIRST_PAGE_SUPPORT',
  },
]

const optionsArmenia = [
  {
    label: 'Фото из паспорта Армении (загруженное поддержкой)',
    value: 'ARMENIA_PHOTO_FROM_PASSPORT_SUPPORT',
  },
  {
    label: 'Селфи (загруженное поддержкой)',
    value: 'ARMENIA_SELFIE_WITH_PASSPORT_SUPPORT',
  },
  {
    label: 'Первая страница паспорта Армении (загруженное поддержкой)',
    value: 'ARMENIA_PASSPORT_FIRST_PAGE_SUPPORT',
  },
  {
    label: 'Фото в системе IDbank (загруженное поддержкой)',
    value: 'ARMENIA_PHOTO_FROM_IDBANK_SUPPORT',
  },
]

const formSchema = Yup.object({
  scanType: Yup.string().required('Заполните поле'),
  image: Yup.string().required('Заполните поле'),
})

export const UploadImageModal = ({ userId }) => {
  const queryClient = useQueryClient()
  const [isOpen, setIsOpen] = useBoolean(false)
  const { mutate: uploadScans, isPending: isLoading } = useUploadScans()
  const userCard = useStore(userCardStore)

  const handleForm = (values) => {
    const image = JSON.parse(values.image)
    const scanString = image.uri.split(',')[1]
    const payload = {
      scanString,
      scanType: values.scanType,
      userId: Number(userId),
    }
    uploadScans(payload, {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['userCard', userId] })
        setIsOpen(false)
      },
    })
  }

  return (
    <>
      <Button colorPalette="orange" size="sm" onClick={() => setIsOpen(true)}>
        Загрузить фотографию
      </Button>
      <Dialog.Root open={isOpen} onOpenChange={(e) => setIsOpen(e.open)}>
        <Portal>
          <Dialog.Backdrop />
          <Dialog.Positioner>
            <Dialog.Content>
              <Dialog.Header>
                <Dialog.Title>Загрузка фототографии</Dialog.Title>
                <Dialog.CloseTrigger mt={1} />
              </Dialog.Header>
              <Dialog.Body>
                <Formik
                  enableReinitialize
                  validationSchema={formSchema}
                  initialValues={{
                    image: '',
                    scanType: '',
                  }}
                  onSubmit={handleForm}
                >
                  {(props) => (
                    <Form onSubmit={props.handleSubmit}>
                      <Stack gap={4}>
                        <Field
                          name="image"
                          label="Изображение"
                          component={FormUploadImage}
                          colorPalette="orange"
                          disabled={isLoading}
                          optionsCropper={{
                            //aspectRatio: 1,
                            maxCropBoxHeight: 1000,
                            maxCropBoxWidth: 1000,
                            minCropBoxHeight: 260,
                            minCropBoxWidth: 260,
                          }}
                          optionsCompress={{
                            maxWidth: 1200,
                            maxHeight: 1200,
                          }}
                          optionsCroppedCanvas={{
                            maxWidth: 1200,
                            maxHeight: 1200,
                          }}
                        />
                        <Field
                          name="scanType"
                          label="Тип"
                          component={SelectForm}
                          placeholder="Выберите ..."
                          options={
                            userCard?.identityCountry === 'RUSSIA' ? optionsRussia : optionsArmenia
                          }
                        />
                      </Stack>
                      <Box pt="30px">
                        <Button type="submit" colorPalette="orange" loading={isLoading}>
                          Загрузить
                        </Button>
                      </Box>
                    </Form>
                  )}
                </Formik>
              </Dialog.Body>
            </Dialog.Content>
          </Dialog.Positioner>
        </Portal>
      </Dialog.Root>
    </>
  )
}
